import styled from '@emotion/styled';
import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';
import { COLORS3 as COLORS, FONT, SPACING } from '@zola/zola-ui/src/styles/emotion';
import { sharedStyles } from '../BudgetContainer/BudgetContainer.styles';

export const BudgetPaymentReminderButton = styled(ButtonV3)<{ extended?: boolean }>`
  ${sharedStyles.rowButton};
  ${FONT.textSizeCompact(FONT.SIZE.SMALL)};
  display: block;
  padding: ${p =>
    p.extended ? `${SPACING.S24} 0 ${SPACING.XS}` : `${SPACING.S16} 0 ${SPACING.XS}`};
  text-align: left;
  &:hover {
    border-bottom: 1px solid ${COLORS.BLACK_100};
  }
`;

export const Section = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Text = styled.p`
  color: ${COLORS.BLACK_100};
  margin-bottom: ${SPACING.XS};
`;

export const Amount = styled.p`
  color: ${COLORS.BLACK_075};
  margin-bottom: ${SPACING.XS};
`;

export const Subtext = styled.p`
  ${FONT.textSizeRegular(FONT.SIZE.SMALLER)};
  color: ${COLORS.BLACK_050};
  margin-bottom: ${SPACING.XXS};
`;
